<template>
  <div class="report-content">
    <div class="top" v-if="titleList.length">
      <van-tabs v-model="curTitle" @click="changeTitle" class="top-nav">
        <van-tab :title="item" v-for="(item, index) in titleList" :key="index">
        </van-tab>
      </van-tabs>
    </div>
    <div class="bottom">
      <div class="scroll-content">
        <div class="data-list" id="data-list">
          <div class="data-item" v-for="(item, index) in dataList" :key="index">
            <div class="item-title" :id="'dataitem-' + index">{{
              item.name
            }}</div>
            <div class="item-table">
              <div class="item-nav-list">
                <div class="item-td left">类型</div>
                <div class="item-td center">总计</div>
                <div class="item-td right">昨日新增</div>
              </div>
              <div class="item-list">
                <div
                  class="item-list-item"
                  v-for="(item1, index1) in item.list"
                  :key="index1"
                >
                  <div class="left">{{ item1.name }}</div>
                  <div class="center">{{ item1.data.all }}</div>
                  <div class="right">
                    <div class="news" v-if="item1.data.yesterday > 0">{{
                      item1.data.yesterday
                    }}</div>
                    <div class="no-news" v-else>无</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <gym-loading class="loading" v-if="!loaded"></gym-loading> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      curTitle: 0,
      titleList: [],
      dataList: [],
      loaded: false
    }
  },
  watch: {
    curTitle(val) {
      document.getElementById('dataitem-' + val).scrollIntoView()
    }
  },
  created() {
    this.getParams(this.$route.query)
    this.getData()
  },
  methods: {
    getParams(options) {
      this.title = options && decodeURIComponent(options.title || '')
      document.title = this.title
    },
    getTitle(data) {
      let res = data.map((item) => {
        return item.name
      })
      return res
    },
    getData() {
      this.$http
        .postApp('member/StorageLogin/typeTj')
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (Array.isArray(res.data)) {
              this.dataList = res.data
              this.titleList = this.getTitle(res.data)
            }
          } else {
            this.$toast(res.msg)
          }
          this.loaded = true
        })
        .catch((e) => {
          this.loaded = true
        })
    },
    changeTitle(index) {
      this.curTitle = index
    }
  }
}
</script>
<style scoped lang="scss">
.report-content {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.report-content .bottom {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}
.loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%);
}
.bottom .scroll-content {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.data-list .item-nav-list {
  box-sizing: border-box;
  height: 43px;
  display: flex;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  letter-spacing: -0.6px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 600;
}
.item-list-item .left,
.item-nav-list .left {
  text-align: left;
  width: 50%;
}
.item-list-item .left {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  letter-spacing: -0.6px;
  color: rgba(0, 0, 0, 0.5);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.item-list-item .center {
  white-space: nowrap;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  letter-spacing: -0.6px;
  color: #000;
}
.item-list-item .news {
  box-sizing: border-box;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  letter-spacing: -0.5px;
  color: #f04646;
  display: inline-block;
  min-width: 36px;
  height: 16px;
  line-height: 16px;
  white-space: nowrap;
}
.item-list-item .no-news {
  font-family: PingFangSC-Medium;
  font-size: 10px;
  letter-spacing: -0.6px;
  color: rgba(0, 0, 0, 0.3);
}
.item-list-item .center,
.item-nav-list .center {
  text-align: center;
  width: 25%;
}
.item-list-item .right,
.item-nav-list .right {
  width: 25%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}
.item-list .item-list-item {
  box-sizing: border-box;
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
}
.item-list .item-list-item:last-child {
  border-bottom: 1px solid transparent;
}
.data-item {
  background-color: #fff;
  padding-bottom: 5px;
}
.item-table {
  padding-left: 40px;
}
.item-title {
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0px 20px;
  font-weight: 600;
  background-color: #f7f7f7;
  height: 38px;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  letter-spacing: -0.6px;
  color: #000;
}
</style>
